import { create } from "zustand";
import { persist } from "zustand/middleware";

type ResizePanelSize = { width?: number; height?: number };
export type OutputMethods = "COPY" | "QRCODE" | "SMARTPASTE" | "GMOHAYABUSA";
export type TranscriptionMode = "whisper" | "amivoice" | "multilingual";

type UseUserConfigsType = {
  resizePanelSize?: ResizePanelSize | null;
  isInputNumberModeActivated: boolean;
  defaultMicrophone: MediaDeviceInfo | null;
  selectedMicrophoneId: string | null;
  selectedMicrophoneName: string | null;
  outputMethod: OutputMethods;
  isOutputWithTitle: boolean;
  transcriptionMode: TranscriptionMode;
  isInputApInfoActivated: boolean;
  isAutomatedTransitionToStandardPlanEnabled: boolean;
  // 診察中に音声波形を表示する
  isRecordingStatusVisible: boolean;
  // 録音中のステータスをタイトルに表示する
  isRecordingStatusTitleVisible: boolean;
  latestNotificationPublishAt?: Date;
  readNotificationIds: string[];
  isAutoCopyEnabled: boolean;
  isMfaEnabled: boolean;
  isTitleGenerationEnabled: boolean;
  setResizePanelSize: (current: ResizePanelSize | null) => void;
  setOutputMethod: (current: OutputMethods) => void;
  setTranscriptionMode: (current: TranscriptionMode) => void;
  setIsOutputWithTitle: (current: boolean) => void;
  setIsInputNumberModeActivated: (current: boolean) => void;
  setDefaultMicrophone: (current: MediaDeviceInfo | null) => void;
  setSelectedMicrophoneId: (current: string | null) => void;
  setSelectedMicrophoneName: (current: string | null) => void;
  setIsInputApInfoActivated: (current: boolean) => void;
  setIsAutomatedTransitionToStandardPlanEnabled: (current: boolean) => void;
  setIsRecordingStatusVisible: (current: boolean) => void;
  setIsRecordingStatusTitleVisible: (current: boolean) => void;
  setLatestNotificationPublishAt: (current: Date) => void;
  setReadNotificationIds: (ids: string[]) => void;
  setIsAutoCopyEnabled: (current: boolean) => void;
  setIsMfaEnabled: (current: boolean) => void;
  setIsTitleGenerationEnabled: (current: boolean) => void;
};

export const useUserConfigs = create(
  persist<UseUserConfigsType>(
    (set) => ({
      resizePanelSize: null,
      defaultMicrophone: null,
      selectedMicrophoneId: null,
      selectedMicrophoneName: null,
      isInputNumberModeActivated: false,
      outputMethod: "COPY",
      isOutputWithTitle: false,
      transcriptionMode: "whisper",
      isInputApInfoActivated: false,
      isAutomatedTransitionToStandardPlanEnabled: false,
      isRecordingStatusVisible: true,
      isRecordingStatusTitleVisible: true,
      latestNotificationPublishAt: undefined,
      readNotificationIds: [],
      isAutoCopyEnabled: true,
      isMfaEnabled: false,
      isTitleGenerationEnabled: true,
      setResizePanelSize: (next) => set({ resizePanelSize: next }),
      setOutputMethod: (next) => set({ outputMethod: next }),
      setIsOutputWithTitle: (next) => set({ isOutputWithTitle: next }),
      setTranscriptionMode: (next) => set({ transcriptionMode: next }),
      setDefaultMicrophone: (current) => set({ defaultMicrophone: current }),
      setSelectedMicrophoneId: (current) =>
        set({ selectedMicrophoneId: current }),
      setSelectedMicrophoneName: (current) =>
        set({ selectedMicrophoneName: current }),
      setIsInputApInfoActivated: (current) =>
        set({ isInputApInfoActivated: current }),
      setIsInputNumberModeActivated: (current) =>
        set({ isInputNumberModeActivated: current }),
      setIsAutomatedTransitionToStandardPlanEnabled: (current) =>
        set({ isAutomatedTransitionToStandardPlanEnabled: current }),
      setIsRecordingStatusVisible: (current) =>
        set({ isRecordingStatusVisible: current }),
      setIsRecordingStatusTitleVisible: (current) =>
        set({ isRecordingStatusTitleVisible: current }),
      setLatestNotificationPublishAt: (current) =>
        set({ latestNotificationPublishAt: current }),
      setReadNotificationIds: (ids) => set({ readNotificationIds: ids }),
      setIsAutoCopyEnabled: (current) => set({ isAutoCopyEnabled: current }),
      setIsMfaEnabled: (current) => set({ isMfaEnabled: current }),
      setIsTitleGenerationEnabled: (current) =>
        set({ isTitleGenerationEnabled: current }),
    }),
    {
      name: "medimo-settings",
    },
  ),
);
